export const abbreviateName = (lastName) => {
  if (!lastName) return '';
  return `${lastName[0].toUpperCase() }.`;
};
